/* =============================================================
 * import
 * ========================================================== */
import Swiper from 'swiper';
import {Autoplay} from 'swiper/modules';
import {mediaQuery} from "../utils/utils";

/* =============================================================
 * function
 * ========================================================== */
const swiperGalleries = [];

export function gallerySwiper() {

  const swipeContents = document.querySelectorAll('.home_concept_swiper');
  let s = 5000;
  if (mediaQuery() === 'pc') {
    s = 10000;
  }

  if (swipeContents.length > 0) {
    swipeContents.forEach((swipeContent, index) => {
      const slides = swipeContent.querySelectorAll('.swiper-slide');

      // 各スライドの幅を取得し、スピードを計算
      const slideSpeeds = Array.from(slides).map(slide => {
        const width = slide.offsetWidth;
        return (width / 50); // 基準速度 (100px = 1秒)
      });

      const initSwiper = () => {
        const swiperInstance = new Swiper(swipeContent, {
          modules: [Autoplay],
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
          },
          slidesPerView: 'auto',
          loop: true,
          loopedSlides: 2,
          grabCursor: false,
          preventClicks: true,
          preventClicksPropagation: true,
          speed: s, // スピードをスライドの合計幅に応じて調整
          on: {
            slideChangeTransitionStart: function() {
              const activeIndex = this.realIndex;
              const slideSpeed = slideSpeeds[activeIndex] * 1000; // 速度をミリ秒に変換
              this.params.speed = slideSpeed; // スライドの速度を設定
              this.update(); // Swiperの設定を更新
            },
          },
        });
        swiperGalleries.push(swiperInstance);
      };

      const destroySwiper = () => {
        if (swiperGalleries[index] && typeof swiperGalleries[index].destroy === 'function') {
          swiperGalleries[index].destroy(true, true);
          swiperGalleries[index] = null;
        }
      };

      const handleSwiper = () => {
        destroySwiper();

        if (!swiperGalleries[index]) {
          if ((slides.length > 3 && mediaQuery() !== 'sp') || (slides.length > 1 && mediaQuery() === 'sp')) {
            initSwiper();
          }
        }
      };

      handleSwiper();
    });
  }
}
